// extracted by mini-css-extract-plugin
export var form = "_ca-0";